import axios from 'axios';

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

// Public axios
export const api = axios.create({ baseURL: API });

// Admin axios with token interceptor
export const adminApi = axios.create({ baseURL: API });
adminApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('ldc_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});
adminApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('ldc_token');
      if (window.location.pathname.startsWith('/admin')) {
        window.location.href = '/admin/login';
      }
    }
    return Promise.reject(err);
  }
);

// Public endpoints
export const fetchContent = () => api.get('/content').then((r) => r.data);
export const fetchServices = () => api.get('/services').then((r) => r.data);
export const fetchPricing = () => api.get('/pricing').then((r) => r.data);
export const fetchWorks = () => api.get('/works').then((r) => r.data);
export const submitLead = (payload) => api.post('/leads', payload).then((r) => r.data);

// Auth
export const login = (username, password) =>
  api.post('/auth/login', { username, password }).then((r) => r.data);
export const me = () => adminApi.get('/auth/me').then((r) => r.data);

// Admin
export const updateContent = (payload) => adminApi.put('/admin/content', payload).then((r) => r.data);

export const adminListLeads = () => adminApi.get('/admin/leads').then((r) => r.data);
export const adminPatchLead = (id, data) => adminApi.patch(`/admin/leads/${id}`, data).then((r) => r.data);
export const adminDeleteLead = (id) => adminApi.delete(`/admin/leads/${id}`).then((r) => r.data);

export const adminCreateService = (data) => adminApi.post('/admin/services', data).then((r) => r.data);
export const adminUpdateService = (id, data) => adminApi.put(`/admin/services/${id}`, data).then((r) => r.data);
export const adminDeleteService = (id) => adminApi.delete(`/admin/services/${id}`).then((r) => r.data);

export const adminCreatePricing = (data) => adminApi.post('/admin/pricing', data).then((r) => r.data);
export const adminUpdatePricing = (id, data) => adminApi.put(`/admin/pricing/${id}`, data).then((r) => r.data);
export const adminDeletePricing = (id) => adminApi.delete(`/admin/pricing/${id}`).then((r) => r.data);

export const adminCreateWork = (data) => adminApi.post('/admin/works', data).then((r) => r.data);
export const adminUpdateWork = (id, data) => adminApi.put(`/admin/works/${id}`, data).then((r) => r.data);
export const adminDeleteWork = (id) => adminApi.delete(`/admin/works/${id}`).then((r) => r.data);

export const adminTestEmail = () => adminApi.post('/admin/test-email').then((r) => r.data);

// File upload (images)
export const adminUploadImage = (file) => {
  const fd = new FormData();
  fd.append('file', file);
  return adminApi
    .post('/admin/upload', fd, { headers: { 'Content-Type': 'multipart/form-data' } })
    .then((r) => r.data);
};
